import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getErrorFormat } from 'core/utils/errors';

const getUrl = ({ host, deviceUuid }: { host: string; deviceUuid: string }) => {
  return `${host}/alert-notifications/${deviceUuid}`;
};

export const DeleteAlertNotification = async ({
  token,
  host,
  deviceUuid,
}: {
  token: string;
  host: string;
  deviceUuid: string;
}): Promise<void> => {
  try {
    const url = getUrl({ host, deviceUuid });

    const options: AxiosRequestConfig = {
      url,
      method: 'DELETE',
      timeout: 10000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: token,
        'Accept-version': '1',
      },
    };

    (await axios(options)) as AxiosResponse<void>;
  } catch (error) {
    throw getErrorFormat(error);
  }
};
